<template>
  <b-container class="blog-post">

    <b-row>
      <b-col md="10" offset-md="1">
        <br>
          <p class="blog-date">10/25/17</p>
          <h1>5 Must-Play Golf Courses In Pickering</h1><br>
          <div class="blog-content">
          <p>Every golf lover knows how hard it is fitting in time on the green… unless you
            live in Pickering! Fresh
            air, stunning scenery, and a great selection of courses are all located conveniently around the Seaton
            area, making your dream of weekly play time a reality.</p>
        
        <br>
        <b-row>
            <b-col md="6">
              <b-img src="/img/blogs/five-must-golf-blog-img-1.png" fluid alt="Pickering Golf Club golf field" class="mb-15"/>
            </b-col>
            <b-col md="6">
              <p class="subtitle">Pickering Golf Club
              </p>
              <p>With a diverse collection of holes, white sand
                bunkers and some of the best manicured greens
                in the area, this course can be enjoyed by golfers
                of all skill levels. Friends, family and business
                associates alike will love gathering at this local
                hotspot for an exciting game or quick practice.</p>

            </b-col>
          
        </b-row>
        <br><br>
        <b-row>
            <b-col md="6">
              <b-img src="/img/blogs/five-must-golf-blog-img-2.png" fluid alt="Watson's Glen Golf Club golf field" class="mb-15"/>
            </b-col>
            <b-col md="6">
              <p class="subtitle">Watson’s Glen Golf Club</p>
              <p>Golf purists will make this premier 18 hole public
                course their second home! Watson’s Glen offers
                an experience that is both challenging and
                rewarding, and is perfect for golfers looking to
                step up their game. Plus, they offer a flex account
                program that includes special benefits and
                discounts at Watson’s Glen and Copper Creek
                Golf Group clubs all around the GTA.</p>
            </b-col>
          
        </b-row>
        <br>
        <b-row>
            <b-col md="6">
              <b-img src="/img/blogs/five-must-golf-blog-img-3.png" fluid alt="Hawthorne Valley Golf Club golf field" class="mb-15" />
            </b-col>
            <b-col md="6">
              <p class="subtitle">Hawthorne Valley Golf Club</p>
              <p>This gorgeous 9 hole golf course has a great
                relaxed feel and friendly staff, making it perfect
                for beginners or a quick afternoon play. The
                amazing Pro Shop, Clubhouse and nearby amenities
                also make it a convenient spot for friends to
                gather on weekends or special occasions!</p>
            </b-col>
        </b-row>
        <br><br>
        <b-row>
            <b-col md="6">
              <b-img src="/img/blogs/five-must-golf-blog-img-4.png" fluid alt="Glen Cedars Golf Club golf field" class="mb-15"/>
            </b-col>
            <b-col md="6">
              <p class="subtitle">Glen Cedars Golf Club</p>
              <p>If you’re looking for a thrilling new experience, you
                definitely need to visit Cherry Downs Golf Club! This
                top-rated course pays homage to the greens at
                Augusta National, making the devilish putting surfaces
                an exciting play for golf-enthusiasts.
                Slippery slopes, plateaus, run-offs and the protective
                surrounds will test your putting mettle, and will make
                any golfer seriously step up their game.</p>
            </b-col>
          
        </b-row>
        <br><br>
        <b-row>
            <b-col md="6">
              <b-img src="/img/blogs/five-must-golf-blog-img-5.png" fluid alt="Cherry Downs Golf Club golf field" class="mb-15"/>
            </b-col>
            <b-col md="6">              
                <p class="subtitle">Cherry Downs Golf Club</p>
                        <p>If you’re looking for a thrilling new experience, you
                            definitely need to visit Cherry Downs Golf Club! This
                            top-rated course pays homage to the greens at
                            Augusta National, making the devilish putting surfaces
                            an exciting play for golf-enthusiasts.
                            Slippery slopes, plateaus, run-offs and the protective
                            surrounds will test your putting mettle, and will make
                            any golfer seriously step up their game.</p><br>
            </b-col>

        </b-row>
        <br>

        <p>Pickering offers an exceptional golfing experience for every skill level, and a
          selection you can’t find
          anywhere else. So if you’re looking for more time on the green, look no further than the future New
          Seaton neighbourhood coming soon!</p>

          </div>
      </b-col>
    </b-row>
    <br>
  </b-container>
</template>

<script>
  export default {
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        this.$root.layout.methods.triggerBlogEnterAnimation(done)
      },
      leave(el, done) {
        this.$root.layout.methods.triggerBlogLeaveAnimation(done)
      },
    },
  }

</script>

<style scoped>

</style>